import classNames from 'classnames';

import React, { forwardRef, ForwardRefExoticComponent, HTMLAttributes, RefAttributes } from 'react';

import styles from './cloud-box-item.scss';

type Props = RefAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement & { dataTestId?: string }>;

const COMPONENT_ID = 'modulor-cloud-box-item';

export const CloudBoxItem: ForwardRefExoticComponent<Props> = forwardRef<HTMLDivElement, Props>(
  ({ children, className, ...rest }, ref, dataTestId = COMPONENT_ID) => {
    return (
      <div
        className={classNames(className, styles['cloudbox-item'])}
        data-testid={dataTestId}
        data-id={dataTestId}
        data-component-name={COMPONENT_ID}
        ref={ref}
        {...rest}>
        {children}
      </div>
    );
  },
);

CloudBoxItem.displayName = 'CloudBoxItem';
